@if (showLdr) {
<ds-loading></ds-loading>
}
<div class="row hdrBar">
  <div class="col-lg-8 col-md-8 mg-a">
    <h1>Vendor Dashboard</h1>
  </div>
  <div class="col-lg-4 col-md-4 mg-a" style="text-align: right"></div>
</div>
<div class="row">
  <div class="col-lg-4 col-md-4 mg-a">
    <p class="slctlbl">Vehicle Vendor</p>
    <nz-select
      class="slctBx"
      nzShowSearch
      [(ngModel)]="selectedvndr"
      (ngModelChange)="onvndrSelect($event)"
      nzPlaceHolder="Select Vehicle Vendor"
      [ngModelOptions]="{ standalone: true }"
    >
      <!-- <nz-option [nzLabel]="'All'" [nzValue]="0" *ngIf="!showVndr"></nz-option> -->
      @for (v of vendorList; track v) {
      <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
      }
    </nz-select>
  </div>
  @if (tntLst && tntLst.length>1) {
  <div class="col-lg-4 col-md-4 mg-a">
    <p class="slctlbl">ULB</p>
    <nz-select
      class="slctBx"
      nzShowSearch
      [(ngModel)]="selectedtenant"
      (ngModelChange)="ontntSelect($event)"
      nzPlaceHolder="Select ULB"
      [ngModelOptions]="{ standalone: true }"
    >
      <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
      @for (t of tntLst; track t) {
      <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
      }
    </nz-select>
  </div>
  } @if (tntLst && tntLst.length==1) {
  <div class="col-lg-4 col-md-4 mg-a">
    <p class="slctlbl">ULB</p>
    <p class="slctlbl dsblTxt">{{ tntLst[0].tnt_nm }}</p>
  </div>
  }
  <div class="col-lg-4 col-md-4 mg-a"></div>
  <!-- <div class="col-lg-3 col-md-3 mg-a">
  <p class="slctlbl">Year</p>
  <nz-select class="slctBx" [(ngModel)]="selectedYear" (ngModelChange)="onSelectMnthYr()"
    [ngModelOptions]="{standalone: true}">
    <nz-option *ngFor="let y of years" [nzValue]="y" nzLabel="{{y}}"></nz-option>
  </nz-select>
</div>

<div class="col-lg-3 col-md-3 mg-a">
  <p class="slctlbl">Month</p>
  <nz-select class="slctBx" [(ngModel)]="selectedmonth" (ngModelChange)="onSelectMnthYr()"
    [ngModelOptions]="{standalone: true}">
    <nz-option *ngFor="let m of months" [nzValue]="m.id" nzLabel="{{m.name}}"></nz-option>
  </nz-select>
</div> -->
</div>
<div class="main">
  <div class="row">
    @for (c of cardSummary; track c) {
    <ul class="cards">
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #816bb1 0%, #5149aa 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Vehicles</h1>
            </div>
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ c.tot_veh === null ? 0 : c.tot_veh }}
                </h1>
                <h1 class="card_sub_title">Total</h1>
              </div>
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ c.ulbs_ct === null ? 0 : c.ulbs_ct }}
                </h1>
                <h1 class="card_sub_title">ULB(s)</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #58d162 0%, #585e0d 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Vehicles Mode</h1>
            </div>
            <!-- <div class="row crdHdr_sb">
              <div class="col-lg-6 col-md-6">
                <h1>
                  <i nz-icon nzType="car" nzTheme="outline"></i>
                </h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <h1 class="card_sub_title"></h1>
              </div>
            </div> -->
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ c.usd_veh == null ? "0" : c.usd_veh }}
                </h1>
                <h1 class="card_sub_title">Regular Vehicles</h1>
              </div>
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ c.spare_veh == null ? "0" : c.spare_veh }}
                </h1>
                <h1 class="card_sub_title">Spare Vehicles</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #3a536b 0%, #145580 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Vehicles Status</h1>
            </div>
            <!-- <div class="row crdHdr_sb">
            <div class="col-lg-6 col-md-6">
              <h1>
                <i nz-icon nzType="car" nzTheme="outline"></i>
              </h1>
            </div>
            <div class="col-lg-6 col-md-6">
              <h1 class="card_sub_title"></h1>
            </div>
          </div> -->
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ c.onl_cnt == null ? "0" : c.onl_cnt }}
                </h1>
                <h1 class="card_sub_title">Online</h1>
              </div>
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ c.off_cnt == null ? "0" : c.off_cnt }}
                </h1>
                <h1 class="card_sub_title">Offline</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #ac4977 0%, #c24459 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Total Drivers</h1>
            </div>
            <!-- <div class="row crdHdr_sb">
          <div class="col-lg-6 col-md-6">
            <h1>
              <i nz-icon nzType="man" nzTheme="outline"></i>
            </h1>
          </div>
          <div class="col-lg-6 col-md-6">
            <h1 class="card_sub_title">{{c.drvr_cnt == null ? "0" : c.drvr_cnt}}</h1>
          </div>
        </div> -->
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ c.drvr_cnt == null ? "0" : c.drvr_cnt }}
                </h1>
                <h1 class="card_sub_title">Drivers</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    }
  </div>
  <div class="main">
    <div class="row bg-wp">
      <h1>Vendor Vehicles Data</h1>
      <div class="ds-card grid tbl">
        <app-data-grid
          [allowedPageSizes]="[10, 20, 30, 50]"
          id="gridContainer"
          style="width: 100%"
          [dataSource]="vehcleTble"
          [legacyColumns]="columnDefs"
          [searchPanel]="true"
          [filterRow]="true"
          [filterPanel]="false"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="true"
          exportFileName="vendor Vehicles Data"
          [pageSize]="10"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          [wordWrapEnabled]="true"
        >
          <!-- [masterDetail]="{ enabled: true, template: 'detail' }" -->

          <app-grid-column
            [showInColumnChooser]="false"
            [visible]="true"
            type="vehicleButtons"
            [width]="100"
            caption="View"
            cellTemplate="editTemplate"
          ></app-grid-column>
          <ng-template appGridCell="editTemplate" let-data="cell"
            ><div>
              <div class="tblEdtBtn" (click)="showVehicles(data, 'all')">
                vehicles
              </div>
            </div></ng-template
          >

          <app-grid-column
            [showInColumnChooser]="false"
            [visible]="true"
            type="offlinesButtons"
            [width]="100"
            caption="View"
            cellTemplate="editTemplate2"
          ></app-grid-column>
          <ng-template appGridCell="editTemplate2" let-data="cell"
            ><div>
              <div class="tblEdtBtn" (click)="showVehicles(data, 'off')">
                Offlines
              </div>
            </div></ng-template
          >
        </app-data-grid>
      </div>
    </div>
    <nz-drawer
      [nzBodyStyle]="{
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        'padding-bottom': '53px'
      }"
      [nzMaskClosable]="false"
      [nzWidth]="1100"
      [nzVisible]="shwSidebar"
      class="sdr"
      (nzOnClose)="closeSideBar()"
    >
      <ng-container *nzDrawerContent>
        <div class="row hdr">
          <div class="col-lg-10 col-md-10">
            <h2 class="sdHdr">{{ sidebarHeading }}</h2>
          </div>
          <div
            class="col-lg-2 col-md-2 mg-a"
            (click)="closeSideBar()"
            style="text-align: right"
          >
            <i
              nz-icon
              nzType="close-circle"
              nzTheme="outline"
              style="font-size: 20px"
            ></i>
          </div>
        </div>
        <div class="row bg-wp">
          <div class="ds-card grid tbl">
            <app-data-grid
              id="gridContainer"
              [dataSource]="vehiclesData"
              [legacyColumns]="columnDefs1"
              [searchPanel]="true"
              [filterRow]="false"
              [filterPanel]="false"
              [groupPanel]="false"
              [columnChooser]="false"
              [allowExport]="true"
              exportFileName="vendor All Vehicles Data"
              [pageSize]="10"
              [allowedPageSizes]="[10, 20, 30, 50]"
              [showPageSizeSelector]="true"
              [rowAlternationEnabled]="true"
              [showBorders]="true"
              [wordWrapEnabled]="true"
            >
              <ng-template appGridCell="editTemplate3" let-data="cell"
                ><div>
                  {{ Disabled }}
                  <nz-select
                    nzShowSearch
                    nzAllowClear
                    nzPlaceHolder="Select Status"
                    style="width: 100%"
                    [(ngModel)]="data.data.asrt_sts_id"
                    (ngModelChange)="changeStatus(data)"
                    [nzDisabled]="Disabled == true"
                  >
                    @for (c of statuses; track c) {
                    <nz-option
                      [nzLabel]="c.asrt_sts_nm"
                      [nzValue]="c.asrt_sts_id"
                    >
                    </nz-option>
                    }
                  </nz-select>
                </div></ng-template
              >

              <ng-template appGridCell="editTemplate4" let-data="cell"
                ><div>
                  <nz-select
                    nzShowSearch
                    nzAllowClear
                    nzPlaceHolder="Select Mode"
                    style="width: 100%"
                    [(ngModel)]="data.data.asrt_spre_in"
                    (ngModelChange)="changeMode(data)"
                  >
                    @for (c of vehMode; track c) {
                    <nz-option
                      [nzLabel]="c.asrt_spre_nme"
                      [nzValue]="c.asrt_spre_in"
                    >
                    </nz-option>
                    }
                  </nz-select>
                </div></ng-template
              >
            </app-data-grid>
          </div>
        </div>
      </ng-container>
    </nz-drawer>
  </div>
</div>
